import { useEffect } from 'react';

// Attribute set on <html> while the user is navigating with the keyboard, so
// Studio inputs can show the focus halo on keyboard focus (Tab) but not on a
// mouse click. This cannot be done in CSS alone: a mouse click on a text field
// always matches :focus and :focus-visible, so it can't be told apart from Tab.
export const STUDIO_KEYBOARD_ATTR = 'data-studio-keyboard';

export const useStudioFocusModality = () => {
  useEffect(() => {
    const root = document.documentElement;
    // Only Tab flips to keyboard mode; typing characters into a
    // pointer-focused field must not make the halo appear mid-edit.
    const handleKeydown = (event: KeyboardEvent) => {
      if (event.key === 'Tab') {
        root.setAttribute(STUDIO_KEYBOARD_ATTR, '');
      }
    };
    const handlePointerdown = () => {
      root.removeAttribute(STUDIO_KEYBOARD_ATTR);
    };
    document.addEventListener('keydown', handleKeydown, true);
    document.addEventListener('pointerdown', handlePointerdown, true);
    return () => {
      document.removeEventListener('keydown', handleKeydown, true);
      document.removeEventListener('pointerdown', handlePointerdown, true);
      root.removeAttribute(STUDIO_KEYBOARD_ATTR);
    };
  }, []);
};
